import React from 'react';
import {useTranslation} from 'react-i18next';
import ConfirmModal from '../../../../incase-domain/components/modals/confirmModal/ConfirmModal';
import {IPresentationFolder} from './types';

export function FolderDeleteModal({
    folder,
    onClose,
    onConfirm,
}: {
    folder: IPresentationFolder | undefined;
    onClose: () => void;
    onConfirm: () => void;
}): JSX.Element {
    const {t} = useTranslation();
    return (
        <ConfirmModal
            isOpen={!!folder}
            title={t('editorPage.folders.deleteFolderTitle')}
            message={
                folder
                    ? t('editorPage.folders.deleteFolderMessage', {
                          name: folder.name,
                          count: folder.presentationCount,
                      })
                    : ''
            }
            color="error"
            onCancel={onClose}
            onConfirm={onConfirm}
            showCancel
            showConfirm
            cancelText={t('common.cancel')}
            confirmText={t('common.confirm')}
            dataCy="folder-delete-modal"
        />
    );
}
